@layer refine.base {
  :host {
    display: none;
    width: 100%;
  }

  :host([active]) {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
  }

  .panel {
    box-sizing: border-box;
    flex: 1;
    height: 100%;
    min-height: 0;
    padding: var(--tab-panel-padding, var(--size-4));
    overflow: auto;
    font-size: var(--tab-panel-font-size, var(--text-sm));
    color: var(--text-color-body);
    animation: var(--_motion-animation, tab-panel-in var(--transition-normal) var(--ease-out) both);
  }
}

@layer refine.variants {
  @keyframes tab-panel-in {
    from {
      opacity: 0;
      translate: 0 4px;
    }

    to {
      opacity: 1;
      translate: 0 0;
    }
  }
}
